import claimGroupEmployeesService from '@services/claim_groups/claim_group_employees.service';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { handleError } from '@rd-web-markets/shared/dist/store/features/alertSlice';
import { Loading } from '@rd-web-markets/shared/dist/util';
import claimEmployeesService from '@rd-web-markets/de/dist/services/claim/claim_employees.service';
import { WagesHeading } from '@rd-web-markets/de/dist/financialSection/wages/WagesHeading';
import { WagesRow } from '@rd-web-markets/de/dist/financialSection/wages/WagesRow';
import { Navigation } from '@rd-web-markets/de/dist/allBase/Navigation';
import { Card, Col, Row } from 'react-bootstrap';
import Table from 'react-bootstrap/Table';
import AllBaseInformationBreadcrumb from '@components/shared/claim_group/base_information/AllBaseInformationBreadcrumb';
export const WagesSection = _ref => {
  let {
    claimGroup,
    accountType,
    type,
    page
  } = _ref;
  const dispatch = useDispatch();
  const [claimEmployees, setClaimEmployees] = useState(null);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const claimEmployees = await claimGroupEmployeesService.all(claimGroup.id, type);
        setClaimEmployees(claimEmployees);
      } catch (e) {
        dispatch(handleError(e.description));
      }
    };
    fetchData();
  }, [claimGroup.id, type]);
  const handleDelete = async index => {
    const employee = claimEmployees[index];
    if (employee.id) {
      try {
        await claimEmployeesService.delete(employee);
        const employees = await claimEmployeesService.all(claimGroup.id, type);
        setClaimEmployees(employees);
      } catch (error) {
        dispatch(handleError(error));
      }
    } else {
      const newEmployees = [...claimEmployees];
      newEmployees.splice(index, 1);
      setClaimEmployees(newEmployees);
    }
  };
  const refreshClaim = () => {};
  if (!claimGroup || !claimEmployees) return /*#__PURE__*/React.createElement(Loading, null);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AllBaseInformationBreadcrumb, {
    claimGroup: claimGroup
  }), /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(Card.Header, null, /*#__PURE__*/React.createElement(Navigation, {
    page: 'wages',
    type: type,
    claim_group: claimGroup,
    accountType: accountType
  })), /*#__PURE__*/React.createElement(Card.Body, null, claimEmployees.length > 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Table, {
    size: "sm",
    className: "pt-4"
  }, /*#__PURE__*/React.createElement("thead", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement(WagesHeading, {
    showTypeAndYear: true
  })), /*#__PURE__*/React.createElement("tbody", null, claimEmployees.map((employee, index) => {
    return /*#__PURE__*/React.createElement(WagesRow, {
      showTypeAndYear: true,
      key: index,
      index: index,
      claim: employee.claim,
      handleDelete: () => handleDelete(index),
      claimEmployees: claimEmployees,
      setClaimEmployees: setClaimEmployees,
      refreshClaim: refreshClaim,
      handleError: handleError
    });
  })))) : /*#__PURE__*/React.createElement(Row, {
    className: "pt-5 pb-5 text-center"
  }, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("h3", {
    className: "text-center text-muted"
  }, "No data"))))));
};